import JSON2CSVBase, {} from './BaseParser.js';
import { fastJoin, flattenReducer } from './utils.js';
export default class JSON2CSVParser extends JSON2CSVBase {
    /**
     * Main function that converts json to csv.
     *
     * @param {Array|Object} data Array of JSON objects to be converted to CSV
     * @returns {String} The CSV formated data as a string
     */
    parse(data) {
        const preprocessedData = this.preprocessData(data);
        if (!this.opts.fields) {
            const fieldSet = new Set();
            for (const item of preprocessedData) {
                for (const field of Object.keys(item)) {
                    fieldSet.add(field);
                }
            }
            this.opts.fields = this.preprocessFieldsInfo([...fieldSet], this.opts.defaultValue);
        }
        const header = this.opts.header ? this.getHeader() : '';
        const rows = this.processData(preprocessedData);
        const csv = (this.opts.withBOM ? '\ufeff' : '') +
            header +
            (header && rows ? this.opts.eol : '') +
            rows;
        return csv;
    }
    /**
     * Preprocess the data according to the give opts (unwind, flatten, etc.)
      and calculate the fields and field names if they are not provided.
     *
     * @param {Array|Object} data Array or object to be converted to CSV
     */
    preprocessData(data) {
        const processedData = Array.isArray(data) ? data : [data];
        if (!this.opts.fields) {
            if (data === undefined || data === null || processedData.length === 0) {
                throw new Error('Data should not be empty or the "fields" option should be included');
            }
            if (processedData[0] === null || typeof processedData[0] !== 'object') {
                throw new Error('Data items should be objects or the "fields" option should be included');
            }
        }
        if (this.opts.transforms.length === 0)
            return processedData;
        return processedData
            .map((row) => this.preprocessRow(row))
            .reduce(flattenReducer, []);
    }
    /**
     * Create the content row by row below the header
     *
     * @param {Array} data Array of JSON objects to be converted to CSV
     * @returns {String} CSV string (body)
     */
    processData(data) {
        return fastJoin(data
            .map((row) => this.processRow(row))
            .filter((row) => row !== undefined), // Filter skipped rows
        this.opts.eol);
    }
}
//# sourceMappingURL=Parser.js.map